export const DEFAULT_LOGO_URL = 'https://res.cloudinary.com/hyvpafifu/image/upload/v1736095467/jyogui/logo/proposal-1-no-words_buywzl.png';
export const DEFAULT_FACEBOOK_URL = 'http://www.facebook.com/jyoguiapp';
export const DEFAULT_YOUTUBE_URL = 'https://www.youtube.com/@jyoguiapp';
export const DEFAULT_INSTAGRAM_URL = 'http://www.instagram.com/jyoguiapp';
export const DEFAULT_TIKTOK_URL = 'http://www.tiktok.com';
export const DEFAULT_WEBSITE_URL = 'http://www.jyogui.fr';
export const DEFAULT_MAILTO = 'info@jyogui.fr';
export const DEFAULT_TELEPHONE = '';



// WEBPACK FOOTER //
// ./src/main/webapp/app/shared/constants/layout.constants.ts